import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    moreOptionsButton: {
        paddingTop: '20px',
    },
}));

export default useStyles;
